import { useMemo } from 'react';

import { t } from 'i18next';

import { CronJob } from '../types';

import { converterForDateAndTime } from 'utils/date';

import { GridColumns } from '@mui/x-data-grid/models/colDef/gridColDef';
import { GridValueFormatterParams } from '@mui/x-data-grid/models/params/gridCellParams';

const dateConverter = ({
  value: date
}: GridValueFormatterParams<Date | null>) =>
  date ? converterForDateAndTime(date) : '';

const useDetailsColumnDefinitions = () => {
  return useMemo<GridColumns<CronJob>>(
    () => [
      {
        field: 'jobName',
        headerName: t('cronJobs.grid.jobName'),
        type: 'string',
        minWidth: 330,
        flex: 1,
        valueFormatter: (params) => t('cronJobs.jobs.' + params.value)
      },
      {
        field: 'previousFireTime',
        headerName: t('cronJobs.grid.previousFireTime'),
        type: 'date',
        minWidth: 100,
        flex: 1,
        valueFormatter: dateConverter
      },
      {
        field: 'nextFireTime',
        headerName: t('cronJobs.grid.nextFireTime'),
        type: 'date',
        minWidth: 100,
        flex: 1,
        valueFormatter: dateConverter
      },
      {
        field: 'lastResult',
        headerName: t('cronJobs.grid.lastResult'),
        type: 'string',
        minWidth: 100,
        flex: 1,
        valueFormatter: ({ value }) =>
          value
            ? t([`cronJobs.grid.status.${value.exitValue}`]) +
              ` (${converterForDateAndTime(value.output.timestamp)})`
            : ''
      }
    ],
    []
  );
};

export default useDetailsColumnDefinitions;
